import { Patient } from "@curai/js-fhir-tools";
import { z } from "zod";

export const profilePhoneNumberFormSchema = z.object({
  phoneNumber: z.string().length(10, "A 10-digit US phone number is required"),
});

const relationshipRoleKeys = Object.keys(Patient.RelationshipRoleTypeLabels);

export const emergencyContactFormSchema = z.object({
  contactName: z.string().min(1, "Name is required"),
  contactPhone: z.string().length(10, "A 10-digit US phone number is required"),
  contactRelationshipRoleType: z
    .string()
    .refine((val) => relationshipRoleKeys.includes(val), {
      message: "Relationship is required",
    }),
});

export const profileAddressFormSchema = z.object({
  addressLine_1: z.string().min(1, "Address line 1 is required"),
  addressLine_2: z.string().optional(),
  city: z.string().min(1, "City is required"),
  state: z
    .string()
    .length(2, "State must be a 2-letter abbreviation")
    .regex(/^[A-Z]{2}$/, "State must be uppercase letters only"),
  postalCode: z.string().min(5, "Postal code must be at least 5 digits"),
});
